import script from "./ContractList.vue?vue&type=script&setup=true&lang=js"
export * from "./ContractList.vue?vue&type=script&setup=true&lang=js"

import "@/assets/styles/sfc/components/objects/ContractList.css?vue&type=style&index=0&id=8f349948&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8f349948"]])

export default __exports__